let
    scrollTimeout = null,
    lazyImages = document.querySelectorAll('img[data-src]');

const
    loadImage = (image, callback = null) => {

        if (image.dataset.src) {

            if (image.offsetWidth > 0) {

                image.addEventListener('load', callback);
                image.setAttribute('src', image.dataset.src);
                image.removeAttribute('data-src');
            }
        }
        else if (callback != null)
            callback();
    },
    lazyLoadImages = () => {

        lazyImages.forEach((image) => {

            const boundingBox = image.getBoundingClientRect();
            if (boundingBox.top <= (window.innerHeight || document.documentElement.clientHeight))
                loadImage(image);
        });
    },
    processingScrolling = () => {

        if (scrollTimeout == null) {
            scrollTimeout = setTimeout(() => {

                lazyLoadImages();
                scrollTimeout = null;
            }, 500);
        }
    },
    delayedLoadImages = () => {

        lazyLoadImages();
        setTimeout(() => {

            const
                images = lazyImages[Symbol.iterator](),
                loadImageByIterator = () => {

                    const iterator = images.next();
                    if (!iterator.done)
                        loadImage(iterator.value, loadImageByIterator);
                };

            loadImageByIterator();

        }, 5 * 1000);
    };

setTimeout(() => {

    delayedLoadImages();
    window.addEventListener('scroll', () => processingScrolling());
    window.addEventListener('resize', () => processingScrolling());
}, 100);
// prevent trigger scroll on load

document.addEventListener('DOMContentUpdated', (e) => {

    lazyImages = document.querySelectorAll('img[data-src]');

    const { target } = e.detail;
    target
        .querySelectorAll('img[data-src]')
        .forEach((image) => loadImage(image));
});